module.exports = __webpack_public_path__ + "static/media/02-speaker_profile.108feb17.webp";